import * as React from 'react';
import { ScreenStatusLevel } from '@app/Screens/types';

interface StatusMeta {
  label: string;
  color: string;
  bg: string;
  dot: string;
}

export const STATUS_META: Record<ScreenStatusLevel, StatusMeta> = {
  ONLINE: { label: 'Online', color: '#047857', bg: 'rgba(5, 150, 105, 0.12)', dot: '#10b981' },
  STALE: { label: 'Stale', color: '#b45309', bg: 'rgba(245, 158, 11, 0.14)', dot: '#f59e0b' },
  OFFLINE: { label: 'Offline', color: '#b91c1c', bg: 'rgba(220, 38, 38, 0.12)', dot: '#ef4444' }
};

export const StatusBadge: React.FunctionComponent<{ status: ScreenStatusLevel; pulse?: boolean }> = ({
  status,
  pulse
}) => {
  const meta = STATUS_META[status] || STATUS_META.OFFLINE;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 9999,
        background: meta.bg,
        color: meta.color,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.2px',
        whiteSpace: 'nowrap'
      }}
    >
      <span
        className={pulse && status === 'ONLINE' ? 'logo-bolt-pulse' : undefined}
        style={{ width: 8, height: 8, borderRadius: '50%', background: meta.dot, flexShrink: 0 }}
      />
      {meta.label}
    </span>
  );
};
